import { ApprovalStatusType } from "../../domain/model/approval-status-type";

export class TrialOverviewWeighingDateViewModel {
  constructor(
    readonly status: ApprovalStatusType,
    readonly date: Date | null = null
  ) { }
}